import { PlaceholdersId, TFComponent } from '@types';
import { LogoBcpPlaceholder } from './logoBcp';

export const logoBcp: TFComponent = {
	component: LogoBcpPlaceholder,
	id: PlaceholdersId.logoBcp,
	name: 'logoBcp',
};
